import makeRequest from 'api/makeRequest';
import environment from 'environment';

/** ******* THE BELOW FUNCTIONS ARE RELATED TO THE COMMON CUSTOMER INTERFACE SPECIFICALLY. DO NOT ADD ANOTHER FUNCTION TO THIS FILE UNLESS IT IS PART OF THE COMMON CUSTOMER INTERFACE AND RETURNS DATA IN THE COMMON CUSTOMER SCHEMA ******* **/

const { CUSTOMER_BASE_URL } = environment.customerData;

export const fetchCustomerInfo = async (customerId, simplrAccountId, shopName) => {
  const url = `${CUSTOMER_BASE_URL}/${customerId}`;
  const config = {
    method: 'get',
    params: {
      simplrAccountId,
      shopName,
    },
  };

  return await makeRequest(url, config);
};

export const patchCustomerNotes = async ({ simplrAccountId, customerId, shopName, note }) => {
  const url = `${CUSTOMER_BASE_URL}/note`;
  const config = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      simplrAccountId,
      customerId: customerId.toString(),
      shopName,
      note,
    },
  };

  return await makeRequest(url, config);
};
